import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import Navbar from "../Navbar"; 
import Footer from "../Footer";
import "./index.css";

const articles = [
  {
    id: 1,
    category: "IMPLANTS",
    title: "Dental Implants: A Complete Guide",
    description:
      "Everything you need to know about modern dental implants — candidacy, procedure, healing and long-term care.",
    path: "/articles/dental-implants",
  },
  {
    id: 2,
    category: "ORTHODONTICS",
    title: "Clear Aligners vs Traditional Braces",
    description:
      "Understand the differences, benefits and what to expect when choosing aligners for your smile.",
    path: "/articles/clear-aligners-vs-braces",
  },
  {
    id: 3,
    category: "ENDODONTICS",
    title: "Root Canal Treatment: Myths & Facts",
    description:
      "A modern, painless walkthrough of what really happens during an RCT — and why it saves your tooth.",
    path: "/articles/root-canal-treatment",
  },
];

const comingSoonArticles = [1, 2, 3];

const Articles = () => {
  return (

    <main className="articles-page">
        <Navbar />
      {/* =====================================================
          HERO SECTION
      ====================================================== */}
      <section className="articles-hero">
        <div className="articles-hero-inner">
          <p className="articles-eyebrow">ARTICLES &amp; INSIGHTS</p>

          <h1 className="articles-main-title">
            Learn. Smile. <em>Take care.</em>
          </h1>

          <p className="articles-hero-description">
            Expert-written dental education designed to help you make confident
            <br className="articles-desktop-break" />
            decisions about your oral health.
          </p>
        </div>
      </section>

      {/* =====================================================
          ARTICLE CARDS
      ====================================================== */}
      <section className="articles-featured-section">
        <div className="articles-container">
          <div className="articles-grid">
            {articles.map((article) => (
              <article className="article-card" key={article.id}>
                <div className="article-card-top">
                  <div className="article-icon">
                    <BookOpen size={27} strokeWidth={1.9} />
                  </div>

                  <p className="article-category">{article.category}</p>

                  <h2 className="article-title">{article.title}</h2>

                  <p className="article-description">{article.description}</p>
                </div>

                <Link to={article.path} className="article-read-link">
                  <span>Read article</span>
                  <ArrowRight size={21} strokeWidth={1.7} />
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* =====================================================
          COMING SOON CARDS
      ====================================================== */}
      <section className="articles-coming-section">
        <div className="articles-container">
          <div className="articles-coming-grid">
            {comingSoonArticles.map((item) => (
              <div className="coming-card" key={item}>
                <BookOpen
                  className="coming-icon"
                  size={43}
                  strokeWidth={1.7}
                />

                <h3>More articles coming soon</h3>

                <p>Dental education library in progress.</p>
              </div>
            ))}
          </div>
        </div>
      </section>
        <Footer />
    </main>
  );
};

export default Articles;